import React, { useState, useCallback, useEffect } from 'react';
import { Button, Spinner } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  getInquiryStaffComments,
  addInquiryStaffComments,
} from '../../../../redux/actions/inquiryActions';
import { FooterButtons } from '../../../../shared/components/Modals/FooterButtons';

import { ModalTextArea } from '../../RefillRequests/Components/ModalTextArea';
import { useInquiryModalContext } from '../utils/InquiryModalContext';

export function InquiryInternalCommentsTab() {
  const dispatch = useDispatch();

  const { inquiryData, closeInquiryModal } = useInquiryModalContext();
  const userId = useSelector((state) => state.user?.profile?._id);
  const { inquiryStaffComments } = useSelector((state) => state.inquiries);

  const [inputValue, setInputValue] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const contactRequestId = inquiryData.id;

  const getStaffComments = useCallback(async () => {
    setIsLoading(true);
    await dispatch(getInquiryStaffComments(contactRequestId));
    setIsLoading(false);
  }, [contactRequestId, dispatch]);

  useEffect(() => {
    if (contactRequestId) {
      getStaffComments();
    }
  }, [contactRequestId, getStaffComments]);

  const handleSubmit = async () => {
    setIsSaving(true);
    await dispatch(
      addInquiryStaffComments(userId, contactRequestId, inputValue),
    );
    setInputValue('');
    setIsSaving(false);
  };

  let content;
  if (isLoading) {
    content = <p>Loading...</p>;
  } else if (!inquiryStaffComments?.length) {
    content = <p>No Staff Notes available.</p>;
  } else {
    content = inquiryStaffComments.map(
      (
        { date, time, authorFullName, comment, authorId, designation },
        index,
      ) => (
        <div className="comment-item" key={index}>
          <p className="comment-info">
            <span>{date}</span>
            <span>{time}</span>
            <span>{userId === authorId ? 'You' : authorFullName}</span>
            {designation && <span>({designation})</span>}
          </p>
          <p className="comment-text">{comment}</p>
        </div>
      ),
    );
  }

  return (
    <>
      <section className="internal-comments-tab">
        <div className="input-wrapper">
          <ModalTextArea
            title="Your Note"
            placeholder="Enter a note regarding this Inquiry..."
            rows={1}
            inputValue={inputValue}
            setInputValue={setInputValue}
          />
          <Button
            className={classNames('btn-yes', { saving: isSaving })}
            onClick={handleSubmit}
            disabled={!inputValue.trim() || isSaving}
          >
            {isSaving ? <Spinner size="sm" /> : 'Submit'}
          </Button>
        </div>
        <h3>Staff Notes History</h3>
        <div className="comments-list scrollable-modal-area">{content}</div>
      </section>

      <FooterButtons onClose={closeInquiryModal} showSaveButton={false} />
    </>
  );
}
